import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export default function useResponsive() {
  return { breakpoints: useBreakpoints(breakpointsTailwind) }
}
